<script lang="ts">
    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import ImageSkeleton from "@components/skeletons/ImageSkeleton.svelte";
    import StackedSkeleton from "@components/skeletons/StackedSkeleton.svelte";
</script>

<div class="gw-rd-referral-program-page-widget__skeleton">
    <div class="gw-rd-referral-program-page-widget__skeleton-benefits">
        <BaseSkeleton width="100%" height="40px" />
        <div
            class="gw-rd-referral-program-page-widget__skeleton-benefits-description"
        >
            <StackedSkeleton count={2} />
        </div>
        <div
            class="gw-rd-referral-program-page-widget__skeleton-benefits-image"
        >
            <ImageSkeleton ratio={1} />
        </div>
    </div>
    <div class="gw-rd-referral-program-page-widget__skeleton-refer-friend">
        <BaseSkeleton width="100%" height="40px" />
        <div
            class="gw-rd-referral-program-page-widget__skeleton-refer-friend-description"
        >
            <StackedSkeleton count={3} gap="10px" height="8px" />
        </div>
        <StackedSkeleton count={3} gap="10px" height="8px" />
    </div>
</div>

<style lang="postcss">
    .gw-rd-referral-program-page-widget__skeleton {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: clamp(
            var(--gw-rd-space-16),
            -16px + 15.2vw,
            var(--gw-rd-space-50)
        );

        &-benefits {
            flex: 1.8 0 288px;

            &-description {
                margin-block: var(--gw-rd-space-8);
            }

            &-image {
                --gw-image-skeleton-backdrop-color: var(--gw-rd-card-bg-color);

                height: clamp(160px, 102.4px + 17.85vw, 240px);
                overflow: hidden;
                border-radius: var(--gw-rd-border-radius-md);
            }
        }

        &-refer-friend {
            flex: 0.5 0 288px;

            &-description {
                margin-block: var(--gw-rd-space-8);
            }
        }
    }
</style>
